import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

@NgModule({
  imports: [
    CommonModule,
  ],
})
export class HttpModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/http/http.module.ts